import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api } from '../lib/api';

export default function Sessions() {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const load = async () => {
    setLoading(true);
    try {
      setSessions(await api.listSessions());
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const del = async (id, name) => {
    if (!confirm(`Delete "${name}"? The videos themselves stay in your library.`)) return;
    await api.deleteSession(id);
    load();
  };

  return (
    <div className="max-w-[1000px] mx-auto p-4">
      <div className="flex items-center justify-between pb-3 border-b border-fairway-800 mb-6">
        <div>
          <h1 className="display text-2xl text-cream-100">Sessions</h1>
          <p className="text-xs text-ink-400 mt-0.5">Your saved swing comparisons.</p>
        </div>
        <button
          onClick={() => navigate('/analyze')}
          className="px-4 py-2 bg-cream-100 text-fairway-950 rounded text-sm font-medium hover:bg-cream-200 transition"
        >
          + New comparison
        </button>
      </div>

      {loading ? (
        <div className="text-ink-400 text-sm">Loading…</div>
      ) : sessions.length === 0 ? (
        <div className="text-center py-16">
          <p className="display text-lg text-ink-200">No sessions yet.</p>
          <p className="text-sm text-ink-400 mt-2">Create your first comparison to see it here.</p>
        </div>
      ) : (
        <div className="space-y-2">
          {sessions.map(s => (
            <div
              key={s.id}
              className="flex items-center justify-between p-4 bg-fairway-900 border border-fairway-800 rounded-lg hover:border-fairway-600 transition"
            >
              <Link to={`/analyze/${s.id}`} className="flex-1 flex items-center gap-4">
                <div className="w-10 h-10 rounded-full bg-fairway-800 flex items-center justify-center text-cream-200 text-sm">
                  ◷
                </div>
                <div>
                  <div className="text-sm text-cream-100 font-medium">{s.name}</div>
                  <div className="text-[11px] text-ink-400 monospace">
                    {new Date(s.updated_at).toLocaleString()}
                    {s.sync_a != null && s.sync_b != null && (
                      <span className="ml-2 text-cream-300">● synced</span>
                    )}
                  </div>
                  {s.notes && <div className="text-xs text-ink-300 mt-1 line-clamp-1">{s.notes}</div>}
                </div>
              </Link>
              <button
                onClick={() => del(s.id, s.name)}
                className="text-ink-500 hover:text-accent-flag transition px-2 text-sm"
                title="Delete session"
              >
                ×
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
